/* unplugin-vue-components disabled */import { render } from "./SvgIconPercent.vue?vue&type=template&id=84103c1a"
import script from "./SvgIconPercent.vue?vue&type=script&lang=js"
export * from "./SvgIconPercent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__